var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',{staticClass:"d-flex justify-center"},[_vm._v("Tempo restante do curso")]),_c('v-card-text',[_c('div',{staticClass:"d-flex justify-center"},[_vm._v(" "+_vm._s(_vm._f("coutdown")(_vm.timer))+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }